import React from 'react';
import {
  GhostDestructiveButton,
  PrimaryActionButton,
  SecondaryActionButton
} from './styles';

type UnitActionButtonVariant = 'primary' | 'secondary' | 'ghost-destructive';

type UnitActionButtonProps = {
  variant: UnitActionButtonVariant;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  'aria-label'?: string;
};

const UnitActionButton: React.FC<UnitActionButtonProps> = ({
  variant,
  children,
  onClick,
  disabled = false,
  type = 'button',
  'aria-label': ariaLabel
}) => {
  const commonProps = {
    type,
    onClick,
    disabled,
    'aria-label': ariaLabel
  };

  if (variant === 'primary') {
    return <PrimaryActionButton {...commonProps}>{children}</PrimaryActionButton>;
  }

  if (variant === 'secondary') {
    return <SecondaryActionButton {...commonProps}>{children}</SecondaryActionButton>;
  }

  return <GhostDestructiveButton {...commonProps}>{children}</GhostDestructiveButton>;
};

export default UnitActionButton;
